import { request } from './request'
// import { recaptcha } from './recaptcha'

const errorMessages = {
    'nl': {
        'required': 'Gelieve dit veld in te vullen.',
        'requiredIf': 'Gelieve minstens 1 van de velden in te vullen:',
        'email': 'Gelieve een e-mailadres in te vullen.',
        'url': 'Gelieve een URL in te vullen.',
        'number': 'Gelieve een nummer in te vullen.',
        'value': 'Gelieve een geldig nummer in te vullen.',
        'pattern': 'Gelieve het gewenste formaat te gebruiken.',
        'invalid': 'Gelieve een geldige waarde in te vullen.',
        'lengthen1': 'Gelieve minstens ',
        'lengthen2': ' tekens te gebruiken. Momenteel zijn dit ',
        'lengthen3': ' tekens.',
        'shorten1': 'Gelieve maximum ',
        'shorten2': ' tekens te gebruiken. Momenteel zijn dit ',
        'shorten3': ' tekens.',
        'maxnumber': 'Gelieve een waarde in te vullen die lager is dan ',
        'minnumber': 'Gelieve een waarde in te vullen die hoger is dan ',
    },
    'en': {
        'required': 'Please fill in this field.',
        'requiredIf': 'Please fill in 1 or more of the fields:',
        'email': 'Please enter an email.',
        'url': 'Please enter a URL.',
        'number': 'Please enter a number.',
        'value': 'Please enter a valid number.',
        'pattern': 'Please match the requested format.',
        'invalid': 'The value you entered for this field is invalid.',
        'lengthen1': 'Please lengthen this text to ',
        'lengthen2': ' characters or more. You are currently using ',
        'lengthen3': ' characters.',
        'shorten1': 'Please shorten this text to no more than ',
        'shorten2': ' characters. You are currently using ',
        'shorten3': ' characters.',
        'maxnumber': 'Please select a value that is no more than ',
        'minnumber': 'Please select a value that is no less than ',
    }
}

function getErrorMessages(language) {
    switch (language) {
        case 'nl':
            var result = errorMessages['nl']
            break

        default:
            var result = errorMessages['en']
            break
    }

    return result
}

function hasError(field) {
    var language = document.documentElement.lang
    var errorMessages = getErrorMessages(language)

    // Don't validate submits, buttons, file and reset inputs, and disabled fields
    if (field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') return

    // Get validity
    var validity = field.validity

    // If valid, return null
    if (validity.valid) return

    // If field is required and empty
    if (field.hasAttribute('data-required-if')) {
        var requiredIf = field.getAttribute('data-required-if')
        var otherField = field.form.querySelector(`#${requiredIf}`)
        var label = field.form.querySelector(`label[for=${field.id}`)
        var otherLabel = field.form.querySelector(`label[for=${requiredIf}`)
        if (otherField.validity.valueMissing) {
            return `${errorMessages.requiredIf} ${label.innerHTML.toLowerCase()}, ${otherLabel.innerHTML.toLowerCase()}`
        } else {
            return
        }
    } else if (validity.valueMissing) return errorMessages.required

    // If not the right type
    if (validity.typeMismatch) {

        // Email
        if (field.type === 'email') return errorMessages.email

        // URL
        if (field.type === 'url') return errorMessages.url
    }

    // If too short
    if (validity.tooShort) return errorMessages.lenghten1 + field.getAttribute('minLength') + errorMessages.lenghten2 + field.value.length + errorMessages.lenghten3

    // If too long
    if (validity.tooLong) return errorMessages.shorten1 + field.getAttribute('maxLength') + errorMessages.shorten2 + field.value.length + errorMessages.shorten3

    // If number input isn't a number
    if (validity.badInput) return errorMessages.number

    // If a number value doesn't match the step interval
    if (validity.stepMismatch) return errorMessages.value

    // If a number field is over the max
    if (validity.rangeOverflow) return errorMessages.maxnumber + field.getAttribute('max') + '.'

    // If a number field is below the min
    if (validity.rangeUnderflow) return errorMessages.minnumber + field.getAttribute('min') + '.'

    // If pattern doesn't match
    if (validity.patternMismatch) {

        // If pattern info is included, return custom error
        if (field.hasAttribute('title')) return field.getAttribute('title')

        // Otherwise, generic error
        return errorMessages.pattern

    }

    // If all else fails, return a generic catchall error
    return errorMessages.invalid
}

function showError(field, error) {
    if (field.hasAttribute('data-novalidate')) return
    
    // Add error class to field
    field.classList.add('error')

    // If the field is a radio button and part of a group, error all and get the last item in the group
    if (field.type === 'radio' && field.name) {
        var group = document.getElementsByName(field.name)
        if (group.length > 0) {
            for (var i = 0; i < group.length; i++) {
                // Only check fields in current form
                if (group[i].form !== field.name) continue
                group[i].classList.add('error')
            }
            field = group[group.length - 1]
        }
    }

    // Get field id or name
    var id = field.id || field.name
    if (!id) return

    // Check if error message field already exists
    // If not, create one
    var message = field.form.querySelector('.error-message#error-for-' + id)
    if (!message) {
        message = document.createElement('div')
        message.className = 'error-message'
        message.id = 'error-for-' + id

        // If the field is a radio button or checkbox, insert error after the label
        var label
        if (field.type === 'radio' || field.type === 'checkbox') {
            label = field.form.querySelector('label[for="' + id + '"]') || field.parentNode
            if (label) {
                label.parentNode.insertBefore(message, label.nextSibling)
            }
        }

        // Otherwise, insert it after the field
        if (!label) {
            field.parentNode.insertBefore(message, field.nextSibling)
        }
    }

    // Add ARIA role to the field
    field.setAttribute('aria-describedby', 'error-for-' + id)

    // Update error message
    message.innerHTML = error

    // Show error message
    message.style.display = 'block'
    message.style.visibility = 'visible'
}

function removeError(field) {
    // Remove error class to field
    field.classList.remove('error')

    // Remove ARIA role from the field
    field.removeAttribute('aria-describedby')

    // If the field is a radio button and part of a group, remove error from all and get the last item in the group
    if (field.type === 'radio' && field.name) {
        var group = document.getElementsByName(field.name)
        if (group.length > 0) {
            for (var i = 0; i < group.length; i++) {
                // Only check fields in current form
                if (group[i].form !== field.name) continue
                group[i].classList.remove('error')
            }
            field = group[group.length - 1]
        }
    }

    // Get field id or name
    var id = field.id || field.name
    if (!id) return

    // Check if an error message is in the DOM
    var message = field.form.querySelector('.error-message#error-for-' + id + '')
    if (!message) return

    // If so, hide it
    message.innerHTML = ''
    message.style.display = 'none'
    message.style.visibility = 'hidden'
}

class Validation {
    init() {
        this.addNovalidate()
        this.blurListener()
        this.submit()
        this.validateSubmitTime()
    }

    validateSubmitTime() {
        var now = new Date()
        this.validSubmitTime = new Date(now.getTime() + 1000)
    }

    addNovalidate() {
        // Add the novalidate attribute when the JS loads
        var forms = document.querySelectorAll('.validate')
        for (var i = 0; i < forms.length; i++) {
            forms[i].setAttribute('novalidate', true)
        }
    }

    blurListener() {
        document.addEventListener('blur', (event) => {
            // Only run if the field is in a form to be validated
            if (!event.target.form) return
            if (!event.target.form.classList.contains('validate')) return

            if (event.target.form.id == "details") {
                var form = event.target.form
                var data = new FormData(form)
                return fetch('', {
                    method: 'POST',
                    body: data
                })
                // .then(response => response.json())
                .catch(error => {
                    console.log('fetch error: ', error)
                })
            }

            // Validate the field
            var error = hasError(event.target)

            // If there's an error, show it
            if (error) {
                showError(event.target, error)
                return
            }

            // Otherwise, remove any existing error message
            removeError(event.target)
            if (event.target.hasAttribute('data-required-if')) {
                var requiredIf = event.target.getAttribute('data-required-if')
                var otherField = event.target.form.querySelector(`#${requiredIf}`)
                removeError(otherField)
            }
        }, true)
    }

    autofillListener(fields) {
        fields.forEach((el) => {
            // Validate the field
            var error = hasError(el)

            // If there's an error, show it
            if (error) {
                showError(el, error)
                return
            }

            // Otherwise, remove any existing error message
            removeError(el)
            if (el.hasAttribute('data-required-if')) {
                var requiredIf = el.getAttribute('data-required-if')
                var otherField = el.form.querySelector(`#${requiredIf}`)
                removeError(el)
            }
        })
    }

    submit() {
        document.addEventListener('submit', (event) => {
            if (event.target.classList.contains('novalidate')) return
            event.preventDefault()

            // Only run on forms flagged for validation
            if (!event.target.classList.contains('validate')) return

            // Get all of the form elements
            var fields = event.target.elements

            // Validate each field
            // Store the first field with an error to a variable so we can bring it into focus later
            var error, hasErrors
            for (var i = 0; i < fields.length; i++) {
                error = hasError(fields[i])
                if (error) {
                    showError(fields[i], error)
                    if (!hasErrors) {
                        hasErrors = fields[i]
                    }
                }
            }

            // If there are errors, don't submit form and focus on first element with error
            if (hasErrors) {
                hasErrors.focus()
                return
            }

            // If form has fetch data attribute, submit with Fetch
            const whitelistedIds = ['login', 'cancel', 'products', 'details', 'generate', 'download']
            if (event.target.getAttribute('id') && whitelistedIds.includes(event.target.getAttribute('id'))) {
                if (event.target.getAttribute('data-form') == 'fetch') {
                    request.submit(event.target)
                } else {
                    event.target.submit()
                }
            } else {
                var now = new Date()
                if (this.validSubmitTime <= now) {
                    recaptcha.submit(event.target)
                } else {
                    event.target.setAttribute('data-form-status', 'error')
                }
            }
            // Otherwise, don't submit
        }, false)
    }
}

export const validation = new Validation()